export default "__VITE_ASSET__BRDViN4Z__"